import PropTypes from 'prop-types';
import { useEffect, useState, useRef } from 'react';
import useActOnExternalClick from '../../hooks/useActOnExternalClick';
import { handleSearchData } from '../../utils/analytics';

function RecipeFilter({
	title, name, items, filters, setFilters,
}) {
	const [open, setOpen] = useState(false);
	const [selection, setSelection] = useState([]);
	const recipeFilter = useRef(null);

	RecipeFilter[`handleClickOutside_${name}`] = () => setOpen(false);

	useEffect(() => {
		let newSelection = [];
		newSelection = filters.filter(
			(item) => item.__typename === title,
		);
		setSelection(newSelection);
	}, [filters, title]);

	const toggleFilter = () => {
		if (!open) {
			// Opening drop-down, make sure selection is set properly.
			let newSelection = [];
			newSelection = filters.filter(
				(item) => item.__typename === title,
			);
			setSelection(newSelection);
		}
		setOpen(!open);
	};

	const handleOnClick = (item) => {
		if (!selection.some((current) => current.id === item.id)) {
			setSelection([...selection, item]);
		} else {
			let selectionAfterRemoval = selection;
			selectionAfterRemoval = selectionAfterRemoval.filter(
				(current) => current.id !== item.id,
			);
			setSelection(selectionAfterRemoval);
		}
	};

	const isSelected = (item) => {
		if (selection.find((current) => current.id === item.id)) {
			return true;
		}
		return false;
	};

	const clear = () => {
		setSelection([]);
	};

	const save = () => {
		let newFilters = [...filters];
		// Add new filters
		selection.forEach((item) => {
			if (!filters.some((current) => current.id === item.id)) {
				newFilters = [...newFilters, item];
			}
		});
		// Remove unselected filters
		newFilters = newFilters.filter(
			(item) => item.__typename !== title || selection.some((current) => current.id === item.id),
		);
		setFilters(newFilters);
		setOpen(false);
		handleSearchData();
	};

	useActOnExternalClick(recipeFilter, open, RecipeFilter[`handleClickOutside_${name}`]);

	return (
		<div className={`recipe-filter${open ? ' popup-open' : ''}`} ref={recipeFilter}>
			<div
				tabIndex={0}
				className="recipe-filter-header"
				role="button"
				onClick={() => toggleFilter()}
				onKeyPress={() => toggleFilter()}
				aria-label={`choose a ${title} to filter by`}
			>
				<span className="recipe-filter-title">{title}</span>
				<span className={`recipe-filter-toggle ${open ? 'up' : 'down'}`} />

			</div>
			{open && (
				<div className="recipe-filter-popup">
					<fieldset className="recipe-filter-list">
						<legend className="visually-hidden">{`${title} (${items.length} items)`}</legend>
						{items.map((item, i) => (
							<div className="recipe-filter-item" key={item.id}>
								{/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
								<label>
									<input
										type="checkbox"
										onClick={() => handleOnClick(item)}
										className={`recipe-filter-checkbox ${isSelected(item) ? 'checked' : ''}`}
									/>
									<span className="recipe-filter-item-name">{item.name}</span>
									<span className="visually-hidden">{`(${i + 1} of ${items.length})`}</span>
								</label>
							</div>

						))}
					</fieldset>
					<div className="recipe-filter-item-actions">
						<button
							className="recipe-filter-clear"
							type="button"
							onClick={() => clear()}
						>
							Clear
							<span className="visually-hidden">your selected filters</span>
						</button>
						<button
							className="recipe-filter-save"
							type="button"
							onClick={() => save()}
						>
							SAVE
							<span className="visually-hidden">your selected filters and run a search</span>
						</button>
					</div>
				</div>
			)}
		</div>
	);
}

RecipeFilter.propTypes = {
	title: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
	items: PropTypes.array.isRequired,
	filters: PropTypes.array.isRequired,
	setFilters: PropTypes.func.isRequired,
};

export default RecipeFilter;
